export default __webpack_public_path__ + "static/media/(65).4e3c1537.jpg";